import 'bootstrap/dist/css/bootstrap.css';
import Carousel from 'react-bootstrap/Carousel';
function UncontrolledExample() {
  return (
   <div style={{ display: 'block', width:'100%', padding: 30 }}>
     <Carousel>
       <Carousel.Item interval={1500}>
       <img
         src="image/comuter.jpg"
         alt="Los Angeles"
         className="d-block"
         style={{ width: "100%" }}
       />
         <Carousel.Caption>
         <h3>Computer</h3>
         <p>Lorem ipsum dolor sit amet.</p>
         </Carousel.Caption>
       </Carousel.Item>

       <Carousel.Item interval={500}>
       <img
         src="image/girl.jpg"
         alt="Chicago"
         className="d-block"
         style={{ width: "100%" }}
       />
         <Carousel.Caption>
         <h3>Pallavi</h3>
         <p>Thank you, Pallavi!</p>
         </Carousel.Caption>
       </Carousel.Item>

       <Carousel.Item interval={500}>
       <img
         src="image/work.jpg"
         alt="New York"
         className="d-block"
         style={{ width: "100%" }}
       />
         <Carousel.Caption>
         <h3>Betul</h3>
         <p>We love the Betul City!</p>
         </Carousel.Caption>
       </Carousel.Item>

     </Carousel>
   </div>
 );
}

export default UncontrolledExample;
